// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart.items);

  /* ---- DN CUSTOM (2023-09-19): Add Free Gift to cart --- */
  function refreshCart(itemCount) {
    window.dnCustomMethods.refreshQuickCart();
    
    if (evt.detail?.app == "spurit-preorder") {
      // Open quick cart if Spurit pre-order app
      window.dnCustomMethods.updateCartCount(itemCount);
      window.dnCustomMethods.openQuickCart();
    }
  } 

  // Check if free product in cart
  const freeGiftBag = {
    productId: 8580211212566,
    handle: "huug-gwp-bag",
    variantIds: [46241354907926, 46241354973462],
  };

  const cartItems = evt.detail.cart.items;
  const freeProduct = cartItems.find(
    (item) => item.product_id === freeGiftBag.productId,
  );

  // If free product not in cart and cart total is over $50
 
  // if (!freeProduct && evt.detail.cart.total_price > 11100) {
  //   // Randomly select variant and add to cart
  //   fetch("/cart/add.js", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       items: [
  //         {
  //           quantity: 1,
  //           id: freeGiftBag.variantIds[Math.floor(Math.random() * freeGiftBag.variantIds.length)],
  //         },
  //       ],
  //     }),
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log("Gift bag successfully added: ", data);
        
  //       refreshCart(evt.detail.cart.item_count + 1);
  //     })
  //     .catch((error) => {
  //       console.error("Gift bag add error:", error);
  //     });
  // } else {
  //   refreshCart(evt.detail.cart.item_count);
  // }
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {

  console.log("Product variant changed");
 // updateThumbnailsForVariant(evt.detail?.variant);
  updateSwiperForVariant(evt.detail?.variant);
  // Update custom slider visibility if present
  /*
  try {
    const variant = evt.detail?.variant;
    const productTitle = document.getElementsByClassName('product__title ')[0]?.innerHTML?.toLowerCase() || '';
    let currentImgAlt = variant?.featured_image?.alt || '';
    if (currentImgAlt.includes('|')) {
      currentImgAlt = currentImgAlt.split('|')[1].trim().toLowerCase();
    } else {
      currentImgAlt = currentImgAlt.toLowerCase();
    }

    document.querySelectorAll('.slider-container .swiper-slide').forEach(function(slide){
      const alt = (slide.getAttribute('thumbnail-alt') || '').toLowerCase();
      const allowed = !alt || alt.includes(currentImgAlt) || alt === productTitle;
      slide.dataset.allowed = allowed ? 'true' : 'false';
    });

    if (window.updateProductSlider) {
      window.updateProductSlider();
    }
  } catch(e) {
    console.warn('updateProductSlider failed', e);
  }
    */
});




/*
function updateSwiperForVariant(variant) {
  if (!variant || !window.swiper) return;
const swiperInstance = document.querySelector('.slider-container').swiper;
  // Build tokens from variant options and featured_image
  const productTitle = document.querySelector('.product__title')?.textContent?.toLowerCase() || '';
  const optionTokens = [variant.option1, variant.option2, variant.option3]
    .filter(Boolean)
    .map(opt => String(opt).toLowerCase());

  let altToken = (variant.featured_image?.alt || '').toLowerCase();
  if (altToken.includes('|')) altToken = altToken.split('|')[1].trim().toLowerCase();

  const tokens = new Set([productTitle, altToken, ...optionTokens].filter(Boolean));

  // Determine which slides to show
  const slides = document.querySelectorAll('.slider-container .swiper-slide');
  slides.forEach(slide => {
    const alt = (slide.getAttribute('thumbnail-alt') || '').toLowerCase();
    const show = alt === '' || Array.from(tokens).some(token => alt.includes(token));
    if(show){
    slide.style.display ='';
    slide.dataset.allowed ='true';
    setTimeout(()=>{

      swiperInstance.slideTo(0,0)
    },250)
    }else{
    slide.style.display ='none';
    slide.dataset.allowed ='false'
    }
    
  });
   swiperInstance.update();

}
*/


function updateSwiperForVariant(variant) {
  if (!variant || !window.swiper) return;
  const swiperInstance = document.querySelector('.slider-container').swiper;
  if (!swiperInstance) return;

  // Build tokens
const productTitle = document.getElementsByClassName('product__title ')[0]?.innerHTML?.toLowerCase() || '';
    let currentImgAlt = variant?.featured_image?.alt || '';
    if (currentImgAlt.includes('|')) {
      currentImgAlt = currentImgAlt.split('|')[1].trim().toLowerCase();
    } else {
      currentImgAlt = currentImgAlt.toLowerCase();
    }

  // Show only matching slides
  const slides = document.querySelectorAll('.slider-container .swiper-slide');
  slides.forEach(slide => {
    const alt = (slide.getAttribute('thumbnail-alt') || '').toLowerCase();

    if(currentImgAlt === alt || alt === '' || alt.toLowerCase() === productTitle || alt.includes(currentImgAlt)){
      slide.style.display = ''
      slide.dataset.allowed = 'true'
    }else{
      slide.style.display = 'none'
      slide.dataset.allowed = 'false'
    }

  });

  // Reset Swiper
  setTimeout(() => {
    swiperInstance.update();
    swiperInstance.slideTo(0, 0);
  }, 100);
}

document.addEventListener('DOMContentLoaded', () => {
  try {
    // Get the current selected variant from your Shopify data
    const variantDataEl = document.getElementById('product-variants');
    console.log('variantDataEl',variantDataEl)
    if (variantDataEl) {
      const variants = JSON.parse(variantDataEl.innerHTML);
      // Find the default selected variant (Shopify marks it as 'selected' or use your logic)
      const selectedVariantId = document.querySelector('[name="id"]')?.value;
      const selectedVariant = variants.find(v => v.id == selectedVariantId);
      if (selectedVariant) {
        updateSwiperForVariant(selectedVariant);
      }
    }
  } catch (e) {
    console.warn('Error initializing Swiper variant on load:', e);
  }
});


// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// --- [START] Thumbnail update logic refactor and page load sync ---
/*
function updateThumbnailsForVariant(variant) {
  const productTitle = document.getElementsByClassName('product__title ')[0]?.innerHTML?.toLowerCase() || '';
  if (!variant) return;

  // Build robust tokens to match images
  //const optionTokens = [variant.option1, variant.option2, variant.option3]
    //.filter(Boolean)
    //.map(v => String(v).toLowerCase());

  //let altToken = (variant.featured_image?.alt || '').toLowerCase();
  //if (altToken.includes('|')) altToken = altToken.split('|')[1].trim().toLowerCase();

  const tokens = new Set([productTitle, altToken, ...optionTokens].filter(Boolean));
  
  // If no meaningful tokens found (blank/default variant), show all media
  const hasColorTokens = optionTokens.some(token => 
    ['black', 'white', 'stone', 'cinnamon', 'cranberry', 'lilac', 'peony', 'beige', 'pink', 'blue', 'purple', 'brown', 'red', 'teal'].includes(token)
  );
  const showAll = tokens.size === 0 || (!hasColorTokens && altToken === '');

  // Desktop thumbnails filter
  document.querySelectorAll('[thumbnail-alt]').forEach(el => {
    const alt = el.getAttribute('thumbnail-alt')?.toLowerCase() || '';
    const show = showAll || alt === '' || Array.from(tokens).some(t => alt.includes(t));
    el.style.display = show ? 'block' : 'none';
  });

  // Slider slides filter (our Swiper slider)
  document.querySelectorAll('.slider-container .swiper-slide').forEach(slide => {
    const alt = (slide.getAttribute('thumbnail-alt') || '').toLowerCase();
    const show = showAll || alt === '' || Array.from(tokens).some(t => alt.includes(t));
    slide.dataset.allowed = show ? 'true' : 'false';
  });

  if (window.updateProductSlider) {
    window.updateProductSlider();
  }
}

// On DOMContentLoaded, update thumbnails to match selected variant

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[data-wair-option-name="Color"] .dynamic-variant-button')
        .forEach(sizeBtn => sizeBtn.classList.remove('disabled'));
  // Find the product form and current variant ID
  const productForm = document.querySelector('[data-product-form]');
  const currentVariantId = productForm?.getAttribute('data-current-product-id');
  // Find the product JSON (look for script tag with id starting with ProductJson-)
  let productJson = null;
  const productJsonScript = document.querySelector('script[id^="ProductJson-"]');
  if (productJsonScript) {
    try {
      productJson = JSON.parse(productJsonScript.textContent);
    } catch (e) {
      console.error('Could not parse product JSON:', e);
    }
  }
  if (productJson && currentVariantId) {
    const variant = (productJson.variants || []).find(v => String(v.id) === String(currentVariantId));
    if (variant) {
      // Patch: featured_image may not be present on variant, so fallback to product's featured_image if needed
      if (!variant.featured_image && productJson.featured_image) {
        variant.featured_image = productJson.featured_image;
      }
      // --- Swiper retry logic for mobile ---
      let attempts = 0;
      function tryUpdateMobileSwiper() {
        if (window.innerWidth > 768) {
          updateThumbnailsForVariant(variant);
          return;
        }
        const swiperContainer = document.querySelector('.product__media-container');
        const swiperWrapper = swiperContainer?.querySelector('.product__media');
        const allSlides = Array.from(swiperWrapper?.querySelectorAll('.swiper-slide') || []);
        const swiperInstance = swiperContainer?.swiper;
        if (!swiperContainer || !swiperWrapper || allSlides.length === 0 || !swiperInstance) {
          if (attempts < 20) {
            attempts++;
            setTimeout(tryUpdateMobileSwiper, 100);
          }
          return;
        }
        updateThumbnailsForVariant(variant);
      }
      tryUpdateMobileSwiper();
    }
  }
});
*/


// document.addEventListener("cart:item-added", function (evt) {
//   console.log("Rebuy Cart Add Event Triggered");

//   let product = evt.detail.product; // Single product object, not an array
//   console.log("Added Product:", product);

//   // Define keywords in the title to exclude
//   const excludedKeywords = ["Flash Sale"]; // Add more if needed

//   // Check if the added product has an excluded keyword in its title
//   let hasExcludedItem = excludedKeywords.some(keyword => 
//     product.product_title.includes(keyword)
//   );

//   console.log("Has Excluded Item:", hasExcludedItem);

//   // Get the progress bar elements
//   let progressBar = document.querySelector("[data-rebuy-component='progress-bar']");
//   let progressBarFill = document.querySelector(".rebuy-cart__progress-bar-meter-fill");

//   if (hasExcludedItem) {
//     // Hide or reset progress bar
//     if (progressBarFill) {
//       progressBarFill.style.width = "0%"; // Reset progress if needed
//       progressBarFill.setAttribute("aria-valuenow", "0");
//     }
//     console.log("Progress bar disabled due to excluded item.");
//   } else {
//     // Show and update progress bar normally
//     if (progressBar) {
//       progressBar.style.display = "block"; // Ensure progress bar is visible
//     }

//     // Fetch updated cart total and exclude invalid products
//     let cartItems = window.Rebuy && window.Rebuy.Cart ? window.Rebuy.Cart.items : [];
    
//     let filteredCartTotal = cartItems
//       .filter(cartProduct => 
//         !excludedKeywords.some(keyword => cartProduct.product_title.includes(keyword))
//       )
//       .reduce((total, cartProduct) => total + (cartProduct.price * cartProduct.quantity), 0);

//     let highestTier = progressBar ? parseFloat(progressBar.getAttribute("data-max-tier")) || 100 : 100;
//     let percentage = Math.min((filteredCartTotal / highestTier) * 100, 100);

//     if (progressBarFill) {
//       progressBarFill.style.width = percentage + "%";
//       progressBarFill.setAttribute("aria-valuenow", Math.round(percentage));
//     }

//     console.log("Updated Progress Bar: " + percentage + "%");
//   }
// });
// ``



// document.addEventListener("cart:updated", function (evt) {
//   console.log("rebuy Cart updated");
  
//   let cartItems = evt.detail.cart.items;
//   console.log("Cart Items:", cartItems);

//   // Define keywords in the title or handle to exclude
//   const excludedKeywords = ["Flash Sale"]; // Add more if needed

//   // Check if any item in the cart has an excluded keyword in the title
//   let hasExcludedItem = cartItems.some(product => 
//     excludedKeywords.some(keyword => product.product_title.includes(keyword))
//   );

//   console.log("Has Excluded Item:", hasExcludedItem);

//   // Get the progress bar elements
//   let progressBar = document.querySelector("[data-rebuy-component='progress-bar']");
//   let progressBarFill = document.querySelector(".rebuy-cart__progress-bar-meter-fill");

//   if (hasExcludedItem) {
//     // Hide or reset progress bar
//     // if (progressBar) {
//     //   progressBar.style.display = "none"; // Hide progress bar
//     // }
//     if (progressBarFill) {
//       progressBarFill.style.width = "0%"; // Reset progress if needed
//       progressBarFill.setAttribute("aria-valuenow", "0");
//     }
//     console.log("Progress bar disabled due to excluded items.");
//   } else {
//     // Show and update progress bar normally
//     if (progressBar) {
//       progressBar.style.display = "block"; // Ensure progress bar is visible
//     }
    
//     // Calculate progress based on valid items
//     let filteredCartTotal = cartItems
//       .filter(product => 
//         !excludedKeywords.some(keyword => product.product_title.includes(keyword))
//       )
//       .reduce((total, product) => total + (product.price * product.quantity), 0);

//     let highestTier = progressBar ? parseFloat(progressBar.getAttribute("data-max-tier")) || 100 : 100;
//     let percentage = Math.min((filteredCartTotal / highestTier) * 100, 100);

//     if (progressBarFill) {
//       progressBarFill.style.width = percentage + "%";
//       progressBarFill.setAttribute("aria-valuenow", Math.round(percentage));
//     }

//     console.log("Updated Progress Bar: " + percentage + "%");
//   }
// });

// Function to check excluded products and update progress bar
function updateProgressBar() {
  console.log("🔄 Rebuy SmartCart:: Checking Cart Items");

  // ✅ SAFETY CHECK: make sure Rebuy + cart exist before touching them
  if (
    !window.Rebuy ||
    !Rebuy.Cart ||
    !Rebuy.Cart.cart ||
    !Array.isArray(Rebuy.Cart.cart.items)
  ) {
    console.log("⚠️ Rebuy Cart not available yet. Skipping progress update.");
    return; // ❗ NO RETRY HERE
  }

  const cartItems = Rebuy.Cart.cart.items;

  if (!cartItems.length) {
    console.log("⚠️ Cart is empty. Skipping progress update.");
    return;
  }

  console.log("🛒 Cart Items:", cartItems);

  // Define keywords in the title to exclude
  const excludedKeywords = ["Flash Sale", "Hipster", "Thong"]; // Add more if needed

  // Filter out only valid items (completely ignore excluded ones)
  const validCartItems = cartItems.filter(
    (item) =>
      item.title &&
      !excludedKeywords.some((keyword) => item.title.includes(keyword))
  );

  const filteredCartTotal = validCartItems.reduce(
    (total, item) => total + parseFloat(item.price) * (item.quantity || 1),
    0
  );

  console.log("📊 Filtered Cart Total (Valid Items Only):", filteredCartTotal);

  // Get the progress bar elements
  const progressBar = document.querySelector(
    "[data-rebuy-component='progress-bar']"
  );
  const progressBarFill = document.querySelector(
    ".rebuy-cart__progress-bar-meter-fill"
  );
  const progressBarFillWrap = document.querySelector(
    ".rebuy-cart__progress-bar-meter-fill_wrap"
  );

  // Custom Labels
  const labelCustom = document.getElementById(
    "rebuy-cart__progress-bar-meter-label_custom"
  );
  const labelCustomCount = document.getElementById(
    "rebuy-cart__progress-bar-meter-label_custom_count"
  );

  if (progressBar) {
    progressBar.style.display = "block"; // Ensure progress bar is always visible
  }

  // Ensure highestTier is set to 15600 for 100% progress
  const highestTier = 15600;

  // Calculate percentage based ONLY on valid items
  const percentage =
    validCartItems.length === 0
      ? 0
      : Math.min((filteredCartTotal / highestTier) * 100, 100);

  const remainingAmount = ((highestTier - filteredCartTotal) / 100)
    .toFixed(2)
    .replace(/\.00$/, "");

  console.log("📈 Corrected Progress Percentage:", percentage);
  console.log("💰 Remaining Amount:", remainingAmount);

  // Show/hide elements based on progress
  if (percentage >= 100) {
    if (labelCustom) labelCustom.style.display = "block"; // Show Free Bra Message
    if (labelCustomCount) labelCustomCount.style.display = "none"; // Hide Countdown
  } else {
    if (labelCustom) labelCustom.style.display = "none";
    if (labelCustomCount) {
      labelCustomCount.style.display = "block";
      labelCustomCount.innerHTML = `You are <span class="dollar">$${remainingAmount}</span> away from a<strong> FREE BRA</strong>`;
    }
  }

  // Update progress bar widths/ARIA
  if (progressBarFill && progressBarFillWrap) {
    progressBarFillWrap.style.width = percentage + "%";
    progressBarFill.style.width = percentage + "%";
    progressBarFill.setAttribute("aria-valuenow", Math.round(percentage));
  }

  console.log("✅ Final Progress Percentage:", percentage);
}

// Ensure the function runs on page load
document.addEventListener("DOMContentLoaded", () => {
  console.log("🚀 DOM Loaded. Checking for cart updates...");
  updateProgressBar(); // Run once on page load
});

// SmartCart Initialization Callback (only used if Rebuy calls this)
function handleInit() {
  if (!window.Rebuy || !Rebuy.Cart) {
    console.log("Rebuy not ready in handleInit, skipping.");
    return;
  }
  console.log("🚀 Rebuy SmartCart:: Init");
  updateProgressBar();
}

// Listen for cart updates to re-run progress bar logic
document.addEventListener("cart:updated", () => {
  console.log("🔄 Cart Updated Event Triggered");
  updateProgressBar();
});

document.addEventListener("cart:item-added", () => {
  console.log("🛍 Item Added Event Triggered");
  updateProgressBar();
});

document.addEventListener("rebuy:cart-updated", () => {
  console.log("🔄 Rebuy Cart Updated Event Triggered");
  updateProgressBar();
});

document.addEventListener("rebuy:cart.add", (event) => {
  console.log("rebuy:cart.add event", event.detail);
  updateProgressBar();
});

document.addEventListener("rebuy:cart.change", (event) => {
  console.log("rebuy:cart.change event", event.detail);
  updateProgressBar();
});



// // Function to check excluded products and update progress bar
// function updateProgressBar(item = null) {
//     console.log("Rebuy SmartCart:: Checking Cart Items");

//     const { SmartCart } = Rebuy;
// console.log('SmartCart',  Rebuy?.Cart?.cart)
//     // Ensure cartItems is always an array
//     let cartItems =  Rebuy?.Cart?.cart?.items;
// //  const excludeProduct = cartItems.find(
// //     (item) => item.title ,
// //   );
//     if (cartItems.length === 0) {
//         console.log("Cart is empty or not loaded yet. Skipping progress update.");
//         return;
//     }

//     console.log("Cart Items:", cartItems);
    
//     // Define keywords in the title to exclude
//     const excludedKeywords = ["Flash Sale"]; // Add more if needed

//     // Check if any cart item contains an excluded keyword
//     let hasExcludedItem = cartItems.some(cartItem =>
//         cartItem.title && excludedKeywords.some(keyword => cartItem.title.includes(keyword))
//     );

//     console.log("Has Excluded Item:", hasExcludedItem);

//     // Get the progress bar elements
//     let progressBar = document.querySelector("[data-rebuy-component='progress-bar']");
//     let progressBarFill = document.querySelector(".rebuy-cart__progress-bar-meter-fill");
// let progressBarFillId = document.querySelector(".rebuy-cart__progress-bar-wrapper");
// console.log("Progress Fill (ID):", progressBarFill );
//     if (progressBar) {
//         progressBar.style.display = "block"; // Ensure progress bar is always visible
//     }

//    // Ensure highestTier is set to 165 for 100% progress
//     let highestTier = 165;
    
//     // Filter out disqualified items and calculate progress
//     let filteredCartTotal = cartItems
//         .filter(cartItem =>
//             cartItem.title && !excludedKeywords.some(keyword => cartItem.title.includes(keyword))
//         )
//         .reduce((total, cartItem) => total + (parseFloat(cartItem.price) * (cartItem.quantity || 1)), 0);
    
//     console.log("Filtered Cart Total (Without Excluded Items):", filteredCartTotal);
    
//     // Calculate percentage based on valid items
//     let percentage = Math.min((filteredCartTotal / highestTier) * 100, 100);
    
//     console.log("Progress Percentage Before Exclusions:", percentage);
    
//     // Ensure excluded items do NOT increase progress
//     if (hasExcludedItem) {
//         console.log("Excluded item found. Progress will not increase.");
//         percentage = Math.min((filteredCartTotal / highestTier) * 100, percentage);
//     }
    
//     // Update progress bar
//     if (progressBarFillId) {
//         progressBarFillId.style.width = percentage + "%";
//         progressBarFillId.setAttribute("aria-valuenow", Math.round(percentage));
//     }
    
//     console.log("Final Progress Percentage:", percentage);

//     if (progressBarFill) {
//         progressBarFillId.style.width = percentage + "%";
//         progressBarFill.style.width = percentage + "%";
        
//         progressBarFill.setAttribute("aria-valuenow", Math.round(percentage));
//     }

//     console.log("Updated Progress Bar: " + percentage + "%");
// }

// // SmartCart Initialization Callback
// function handleInit() {
//     const { SmartCart } = Rebuy;
//     console.log("Rebuy SmartCart:: init", SmartCart);

//     // Run progress bar update when SmartCart initializes
//     updateProgressBar();
// }

// // Listen for cart updates to re-run progress bar logic
// document.addEventListener("cart:item-added", (evt) => {
//     if (evt.detail && evt.detail.item) updateProgressBar(evt.detail.item);
// });
// document.addEventListener("cart:item-updated", (evt) => {
//     if (evt.detail && evt.detail.item) updateProgressBar(evt.detail.item);
// });
// document.addEventListener("cart:updated", updateProgressBar);
// document.addEventListener("rebuy:cart-updated", updateProgressBar);
// // Listen for cart updates to re-run progress bar logic
// document.addEventListener("cart:updated", updateProgressBar);
// document.addEventListener("cart:item-added", updateProgressBar);
// document.addEventListener("rebuy:cart-updated", updateProgressBar);

// // Run progress update on SmartCart init
// handleInit();

// // document.addEventListener('rebuy:cart.change', (event) => { 
// //   console.log('rebuy:cart.change event', event.detail); 
// // });

document.querySelectorAll('.dynamic-variant-button').forEach(btn => {
  btn.addEventListener('click', function() {
    const selectedColor = this.dataset.optionValue; // Or use innerText if no dataset
    console.log("Color clicked:", selectedColor);

    // Step 2: Filter all variants matching this color
    // const availableVariants = allVariants.filter(v => v.option1 === selectedColor || v.option2 === selectedColor);

    // Step 3: Extract the available sizes for that color
    // const availableSizes = availableVariants.map(v => v.option2); // assuming option2 = size
    // console.log("Available sizes for this color:", availableSizes);

    // Step 4: Update UI (enable only available size buttons, disable others)
    // document.querySelectorAll('.size-button').forEach(sizeBtn => {
    //   if (availableSizes.includes(sizeBtn.dataset.size)) {
    //     sizeBtn.disabled = false;
    //     sizeBtn.classList.remove("disabled");
    //   } else {
    //     sizeBtn.disabled = true;
    //     sizeBtn.classList.add("disabled");
    //   }
    // });
  });
});
